import { useState } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Translate } from 'react-localize-redux'

// Material-UI imports
import { Modal } from '@material-ui/core'

import Typography from '@material-ui/core/Typography'

// Imports from own project
import styles from './TypeInfoModalContainer.module.scss'
import DataTypes from 'constants/DataTypes'
import { CloseIcon, Ranges, EngRanges } from 'icons'
import NewIndicator from 'common/components/Indicators/NewIndicators/NewIndicators'
import { getGoIaqsMeterProps } from 'common/components/IndicatorsSection/IndicatorsSection.utils'
import { ReactComponent as Initializing } from 'icons/initializing.svg'
import GoIaqsInfoPanel from 'common/components/IndicatorsSection/GoIaqsInfoPanel'

const TypeInfoModalContainer = props => {
  const { hideModal, translate, type, activeLanguage, numericValue, vocsType, dominantPollutants } =
    props

  const [open] = useState(true)

  const getTitle = type => {
    switch (type) {
      case DataTypes.THERMAL_INDICATOR:
        return translate('thermalIndicatorTitle')
      case DataTypes.VENTILATION_INDICATOR:
        return translate('ventilationIndicatorTitle')
      case DataTypes.COVID_19:
        return translate('virusIndicatorTitle')
      case DataTypes.IAQ:
        return translate('iaqIndicatorTitle')
      case DataTypes.MOLD_INDICATOR:
        return translate('moldIndicatorTitle')
      case DataTypes.GO_IAQS:
        return translate('goIaqsIndicatorTitle')
      default:
        break
    }
  }

  const getContent = type => {
    let translateTextId

    switch (type) {
      case DataTypes.THERMAL_INDICATOR:
        translateTextId = 'thermalIndicatorInfo'
        break
      case DataTypes.VENTILATION_INDICATOR:
        translateTextId = vocsType ? 'ventilationIndicatorInfo' : 'ventilationIndicatorNoVocsInfo'
        break
      case DataTypes.COVID_19:
        translateTextId = 'virusIndicatorInfo'
        break
      case DataTypes.IAQ:
        translateTextId = 'iaqIndicatorInfo'
        break
      case DataTypes.MOLD_INDICATOR:
        translateTextId = 'moldIndicatorInfo'
        break
      case DataTypes.GO_IAQS:
        translateTextId = 'goIaqsIndicatorInfo'
        break
      default:
        return null
    }

    if (type === DataTypes.MOLD_INDICATOR && numericValue === 'p') {
      return (
        <div className={styles.initializingBlock}>
          <Initializing className={styles.initializingIcon} />
          <div className={styles.initializingDescription}>{translate('moldInitializingInfo')}</div>
        </div>
      )
    }

    if (translateTextId) {
      return (
        <div className={styles.modalInfoText}>
          <Translate
            id={translateTextId}
            options={{ renderInnerHtml: true }}
          />
        </div>
      )
    }
  }

  const handleMoreInformationClick = type => {
    switch (type) {
      case DataTypes.THERMAL_INDICATOR:
        return 'https://inbiotair.com/wikinbiot/indicadore-confort-termohigrometrico'
      case DataTypes.VENTILATION_INDICATOR:
        return 'https://www.inbiotair.com/wikinbiot/indicador-eficacia-ventilacion'
      case DataTypes.IAQ:
        return 'https://inbiotair.com/wikinbiot/indicador-calidad-de-aire-interior'
      case DataTypes.COVID_19:
        return 'https://inbiotair.com/wikinbiot/indicador-resistencia-virus'
      case DataTypes.MOLD_INDICATOR:
        return 'https://www.inbiotair.com/wikinbiot/resistance-to-mold-growth-indicator'
      default:
        return '#'
    }
  }

  return (
    <Modal
      open={open}
      onClose={hideModal}
      arial-labelledby='simple-modal-title'
      arial-desccribedby='simple-modal-description'
    >
      <div className={styles.content}>
        <div className={styles.modalContainer}>
          <div className={styles.closeButtonPosition}>
            <button
              className={styles.closeModalArrow}
              onClick={hideModal}
            >
              <img
                src={CloseIcon}
                alt='close'
              />
            </button>
          </div>

          <Typography className={styles.header}>{getTitle(type)}</Typography>
          {type !== DataTypes.GO_IAQS && (
            <>
              {numericValue !== undefined &&
                !(type === DataTypes.MOLD_INDICATOR && numericValue === 'p') && (
                  <div className={styles.indicatorWrapper}>
                    <NewIndicator
                      numericValue={numericValue}
                      {...getGoIaqsMeterProps(type)}
                    />
                  </div>
                )}
              <div className={styles.modal}>
                {getContent(type)}
                <div className={styles.contentImage}>
                  <img
                    src={activeLanguage.code === 'es' ? Ranges : EngRanges}
                    alt='Images'
                    className={styles.images}
                  />
                </div>
              </div>
            </>
          )}
          {type === DataTypes.GO_IAQS && (
            <div className={cx(styles.modal, styles.goIaqsModalContent)}>
              <GoIaqsInfoPanel
                value={numericValue}
                dominantPollutants={dominantPollutants}
                isModal
                showTitle={false}
              />
            </div>
          )}
          {/* GO_IAQS doesn't have an external link so it shouldn't show */}
          {type !== DataTypes.GO_IAQS && (
            <div className={styles.infoButton}>
              <a
                href={handleMoreInformationClick(type)}
                target='_blank'
                className={styles.informationButton}
                rel='noreferrer'
              >
                {translate('learnMore')}
              </a>
            </div>
          )}
        </div>
      </div>
    </Modal>
  )
}

TypeInfoModalContainer.propTypes = {
  hideModal: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired
}

export default TypeInfoModalContainer
